module.exports = __webpack_public_path__ + "assets/Tangent1.b8b6724414e3021ed7516d7d316aa0c4.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/Tangent1.gmt
// module id = 1017
// module chunks = 0